<template>
  <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners">
    <span slot="title">
      <span>{{ menuInfo.title }}</span>
    </span>
    <template v-for="item in menuInfo.children">
      <WsMenuTreeItem
        v-if="Array.isArray(item.children) && item.children.length > 0"
        :key="item.key"
        :menu-info="item"
      />
      <a-menu-item v-else :key="item.key">
        <span>{{ item.title }}</span>
      </a-menu-item>
    </template>
  </a-sub-menu>
</template>
<script>
import { Menu } from "ant-design-vue";

export default {
  name: "WsMenuTreeItem",
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
};
</script>
<style>
</style>
